/** @jsxImportSource @emotion/react */
import MoveAnalysisModal from '../core/MoveAnalysisModal';
import * as s from './style';
import React, { useEffect } from 'react';
import MapPopupFrame from './MapPopupFrame';

const PopulationPopup = ({
    selectedLocation,
    handlePopupClose,
    onClickPopDetailButton,
    setMovPopParams,
    populationPopupState,
    setPopulationPopupState,
    setLineLayerVisible
}) => {
    useEffect(() => {
        return () => {
            setPopulationPopupState('pop');
        };
    }, [selectedLocation, setPopulationPopupState]);

    const onClickmovPopButtonHandle = () => {
        setPopulationPopupState('mov');
    };

    const hasLocation = Boolean(selectedLocation);
    const shouldShowPop = populationPopupState === 'pop' && hasLocation;

    const handleMoveModalClose = () => {
        setPopulationPopupState('pop');
        handlePopupClose();
    };

    const statRows = [
        {
            label: '인구수',
            value: `${selectedLocation?.popCnt?.toLocaleString() || 0}명`,
        },
        { label: '점유율', value: `${selectedLocation?.popShare || 0}%` },
        {
            label: '전입 인구수',
            value: `${selectedLocation?.iPopCnt?.toLocaleString() || 0}명`,
        },
        {
            label: '전출 인구수',
            value: `${selectedLocation?.oPopCnt?.toLocaleString() || 0}명`,
        },
        { label: '연평균 증감률', value: `${selectedLocation?.popRate || 0}%` },
    ];

    return (
        <>
            <MapPopupFrame
                popupId="population_popup"
                isVisible={shouldShowPop}
                title={selectedLocation?.hjdNm ?? ''}
                onClose={handlePopupClose}
                containerCss={s.mapContainer}
                footer={
                    <div className="map-popup-buttons">
                        <button
                            id="moveAnalysisBtn"
                            className="map-primary-button"
                            onClick={onClickmovPopButtonHandle}
                        >
                            이동특성분석
                        </button>
                        <button
                            id="populationDetailBtn"
                            className="map-secondary-button"
                            onClick={onClickPopDetailButton}
                        >
                            인구분포 상세조회
                        </button>
                    </div>
                }
            >
                {statRows.map((row) => (
                    <div className="map-popup-item" key={row.label}>
                        <span className="map-popup-label">{row.label} : </span>
                        <span className="map-popup-value">{row.value}</span>
                    </div>
                ))}
            </MapPopupFrame>

            {populationPopupState === 'mov' && (
                <MoveAnalysisModal
                    isOpen
                    onClose={handleMoveModalClose}
                    setMovPopParams={setMovPopParams}
                    setLineLayerVisible={setLineLayerVisible}
                />
            )}
        </>
    );
};

export default PopulationPopup;
